module.exports = __webpack_public_path__ + "static/img/4数字农场高精度地图基础设施.65b20f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/解决方案/智慧农场解决方案/4数字农场高精度地图基础设施.png
// module id = cuNS
// module chunks = 0